module.exports = __webpack_public_path__ + "static/media/blue-tick.3f1a4873.png";